import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const PillContainer = styled.div`
  cursor: pointer;
  height: 32px;
  padding: 6px;
  display: flex;
  align-items: center;
  border: ${props => props.visited && `1px solid ${props.theme.color.primary}`};
  border-radius: 16px;

  background-color: ${props => props.active && `${props.theme.color.primary}`};

  ${props => (!props.visited || props.active) && 'pointer-events: none;'}
`;

const StepNumber = styled.div`
  height: 16px;
  width: 16px;
  font-size: 10px;
  text-align: center;
  line-height: 16px;
  border-radius: 8px;
  color: ${props => props.theme.color.base3};
  border: 1px solid ${props => props.theme.color.base3};

  border-color: ${props => (props.active && props.theme.color.white) || (props.visited && props.theme.color.primary)};
  color: ${props => (props.active && props.theme.color.primary) || (props.visited && props.theme.color.white)};
  background-color: ${props =>
    (props.active && props.theme.color.white) || (props.visited && props.theme.color.primary)};
`;

const Label = styled.div`
  font-size: 14px;
  color: ${props => props.theme.color.base3};
  margin-left: 8px;

  color: ${props => (props.active && props.theme.color.white) || (props.visited && props.theme.color.primary)};
`;

class StepPill extends Component {

  goTo = () => {
    const {goToStep, index} = this.props;
    goToStep(index);
  }
  render() {
    const { currentStep, visitedStep, label, index } = this.props;
    const active = currentStep === index;
    const visited = index <= visitedStep;

    return (
      <PillContainer active={active} visited={visited} index={index} onClick={this.goTo}>
        <StepNumber active={active} visited={visited}>
          {index + 1}
        </StepNumber>
        <Label active={active} visited={visited}>
          {label}
        </Label>
      </PillContainer>
    );
  }
}

StepPill.propTypes = {
  currentStep: PropTypes.number,
  visitedStep: PropTypes.number,
  label: PropTypes.string,
  index: PropTypes.number,
  goToStep: PropTypes.func
};

export default StepPill;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/components/StepPill.js